module.exports = __webpack_public_path__ + "static/media/logo_dark.d191128e.png";